module.exports = function isBoolean(x) {
  return x === true || x === false;
};


//////////////////
// WEBPACK FOOTER
// ../~/tcomb/lib/isBoolean.js
// module id = 380
// module chunks = 1